import { Navigate } from 'react-router-dom';
import { useTenant } from '../components/TenantContext.jsx';

/**
 * 經銷商診斷 route 守衛：accountRole ∈ {dealer, super_admin} 才放行。
 * 一般商用/子帳號 deep-link /dealer/* 導回首頁。
 * 真正的權限邊界在 server：admin-console blockNonDealerOps + ivr-builder-api requireDealer(含 ownership)。
 */
export function RequireDealer({ children }) {
    const { accountRole, loading } = useTenant();
    if (loading) {
        return (
            <div className="grid min-h-dvh place-items-center text-ink-500">
                <div className="font-mono text-sm">Loading…</div>
            </div>
        );
    }
    if (accountRole !== 'dealer' && accountRole !== 'super_admin') return <Navigate to="/" replace />;
    return children;
}
